export const getSize = (size: number | string | undefined, amountOfColumns: number) => {
  if (typeof size === 'number') return `${size}px`;
  if (size === 'large') return `${((1 / amountOfColumns) * 100) + 5}%`;

  return size;
};
